export default __webpack_public_path__ + "static/media/ART15.78de57b2.jpg";